import React from 'react';
import { readinessToneMap } from '../lib/recoveryRolloutFormatters';

const RolloutStatusBadge = ({ status = 'BLOCKED' }) => {
  const key = String(status || 'BLOCKED').toUpperCase();
  const tone = readinessToneMap[key] || readinessToneMap.BLOCKED;

  return (
    <span className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] font-semibold ${tone}`}>
      {key}
    </span>
  );
};

export default RolloutStatusBadge;
